import{__require as r}from"./function-uncurry-this.js";var n,t;function i(){if(t)return n;t=1;var i=r(),o=0,u=Math.random(),e=i(1..toString);return n=function(r){return"Symbol("+(void 0===r?"":r)+")_"+e(++o+u,36)}}export{i as __require};
//# sourceMappingURL=uid.js.map
